export type YesNo = 'yes' | 'no';

export type EarnerRole = 'spouse' | 'parent' | 'child' | 'sibling' | 'other_relative' | 'other';

export type MemberToEarnerRelationship = 'child' | 'parent' | 'spouse' | 'sibling';

export type OtherIncomeChangeReason =
  | 'started'
  | 'stopped'
  | 'marriage'
  | 'divorce'
  | 'death'
  | 'other';

export const MAX_OTHER_INCOME_CLAIM_ENTRIES = 2;

export type OtherIncomeEarnerStep =
  | 'intro'
  | 'anyClaimedGate'
  | 'pickMember'
  | 'earnerRole'
  | 'earnerRoleOther'
  | 'earnerName'
  | 'earnerAddress'
  | 'memberToEarnerRelationship'
  | 'changedDuringYear'
  | 'changeDate'
  | 'changeReason'
  | 'changeReasonOther'
  | 'addAnother'
  | 'review';

export type FamilyMemberCandidate = {
  empFamilyId: number;
  fullName: string;
  relationship: string;
  claimedByOtherIncome: boolean;
  otherEarnerName: string;
  otherEarnerAddress: string;
};

export type OtherIncomeClaimEntry = {
  empFamilyId: number;
  memberFullName: string;
  memberRelationship: string;
  earnerRole: EarnerRole | '';
  earnerRoleOther: string;
  earnerName: string;
  earnerAddress: string;
  memberToEarnerRelationship: MemberToEarnerRelationship | '';
  changedDuringYear: YesNo | '';
  changeDate: string;
  changeReason: OtherIncomeChangeReason | '';
  changeReasonOther: string;
};

export type OtherIncomeEarnerSnapshot = {
  anyClaimedByOther: YesNo | '';
  entries: OtherIncomeClaimEntry[];
};

export type OtherIncomeClaimDraft = OtherIncomeClaimEntry;

export const EARNER_ROLE_OPTIONS: EarnerRole[] = [
  'spouse',
  'parent',
  'child',
  'sibling',
  'other_relative',
  'other',
];

export const MEMBER_TO_EARNER_RELATIONSHIP_OPTIONS: MemberToEarnerRelationship[] = [
  'child',
  'parent',
  'spouse',
  'sibling',
];

export const OTHER_INCOME_CHANGE_REASON_OPTIONS: OtherIncomeChangeReason[] = [
  'started',
  'stopped',
  'marriage',
  'divorce',
  'death',
  'other',
];

export const OTHER_INCOME_EARNER_STEP_ORDER: OtherIncomeEarnerStep[] = [
  'intro',
  'anyClaimedGate',
  'pickMember',
  'earnerRole',
  'earnerRoleOther',
  'earnerName',
  'earnerAddress',
  'memberToEarnerRelationship',
  'changedDuringYear',
  'changeDate',
  'changeReason',
  'changeReasonOther',
  'addAnother',
  'review',
];

export const MEMBER_LOOP_STEPS: OtherIncomeEarnerStep[] = [
  'pickMember',
  'earnerRole',
  'earnerRoleOther',
  'earnerName',
  'earnerAddress',
  'memberToEarnerRelationship',
  'changedDuringYear',
  'changeDate',
  'changeReason',
  'changeReasonOther',
];

export function emptyOtherIncomeClaimDraft(): OtherIncomeClaimDraft {
  return {
    empFamilyId: 0,
    memberFullName: '',
    memberRelationship: '',
    earnerRole: '',
    earnerRoleOther: '',
    earnerName: '',
    earnerAddress: '',
    memberToEarnerRelationship: '',
    changedDuringYear: '',
    changeDate: '',
    changeReason: '',
    changeReasonOther: '',
  };
}

export function emptyOtherIncomeEarnerSnapshot(): OtherIncomeEarnerSnapshot {
  return { anyClaimedByOther: '', entries: [] };
}
